var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["I18nextProvider"]: () => (__WEBPACK_EXTERNAL_MODULE_react_i18next_31085753__.I18nextProvider), ["Trans"]: () => (__WEBPACK_EXTERNAL_MODULE_react_i18next_31085753__.Trans), ["useTranslation"]: () => (__WEBPACK_EXTERNAL_MODULE_react_i18next_31085753__.useTranslation) });